import { Card, CardBody, Col } from "reactstrap";
import { RoundedTouchspinTitle } from "../../../../../../Constants/Constants";
import { DefaultTouchspinData, TouchspinSubTitle } from "../../../../../../Data/Forms&Table/Forms/FormWidgets";
import CommonCardHeader from "../../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import CommonTouchspin from "../Common/CommonTouchspin";

const RoundedTouchspin = () => {
  return (
    <Col xl="12">
      <Card>
        <CommonCardHeader title={RoundedTouchspinTitle} span={TouchspinSubTitle} />
        <CardBody className="common-flex rounded-touchspin">
          {DefaultTouchspinData.map((data, index) => (
            <CommonTouchspin key={index} arrowIcon={true} color={data} btnClass={`touchspin-${data}`} />
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};
export default RoundedTouchspin;
